import { ContactTemplate } from '@flowwai-frontend/bps-officer-web/graphql'
import { Sales_Crm_Web_Common_Gof_FragmentFragment } from '@flowwai-frontend/bps-officer-web/graphql-docs'
import {
   ContactTemplateType,
   TemplateDetailsStatusEnum,
   useAccountStore,
   useContactTemplatesStore
} from '@flowwai-frontend/shared/sales-crm/sales-crm-core'

import { convertToGoFWithFieldsType } from '../../../transformers/template'

import { GetContactTemplateQuery as Query } from './query.generatedTypes'

interface ResponseArgsType {
   data: Query

   onHandleError: (
      errorMessage: string,
      data: Query['getUserAppConfig']
   ) => void

   onSuccess?: () => void
}

interface ReturnType {
   handleAPIResponse: (args: ResponseArgsType) => void
}

const useAPIResponseHandler = (): ReturnType => {
   const contactTemplateStore = useContactTemplatesStore()
   const accountStore = useAccountStore()

   const convertContactTemplateModelInputType = (
      contactTemplate: ContactTemplate
   ): ContactTemplateType => {
      const {
         contactTemplateId,
         gofs,
         name,
         assigneeFieldsMapping,
         identificationFieldIds
      } = contactTemplate

      return {
         templateId: contactTemplateId,
         name: name,
         gofs: gofs.map(gof =>
            convertToGoFWithFieldsType(
               gof as Sales_Crm_Web_Common_Gof_FragmentFragment
               //TODO: need to resolve type issue
            )
         ),
         assigneeFieldsMapping: assigneeFieldsMapping,
         workflows: [],
         identificationFieldIds
      }
   }

   const handleAPIResponse = (args: ResponseArgsType): void => {
      const { getUserAppConfig } = args.data

      switch (getUserAppConfig.__typename) {
         case 'UserAppConfig': {
            const contactTemplate = getUserAppConfig.contactTemplate

            switch (contactTemplate.__typename) {
               case 'ContactTemplate': {
                  const transformedContactTemplate: ContactTemplateType = convertContactTemplateModelInputType(
                     contactTemplate as ContactTemplate
                  )

                  contactTemplateStore.createOrUpdateTemplate(
                     transformedContactTemplate
                  )
                  contactTemplateStore
                     .getTemplate(transformedContactTemplate.templateId)
                     .setTemplateDetailsStatus(
                        TemplateDetailsStatusEnum.FetchedCompleteDetails
                     )

                  accountStore.setContactTemplateId(
                     contactTemplate.contactTemplateId
                  )

                  break
               }

               default:
                  throw new Error(
                     `__typename:${getUserAppConfig.contactTemplate.__typename}: Unhandled Response type`
                  )
            }

            args.onSuccess?.()
            break
         }
         default: {
            args.onHandleError?.('Unhandled error type', getUserAppConfig)
         }
      }
   }

   return { handleAPIResponse }
}

export default useAPIResponseHandler
